import React, { useState, useEffect, useReducer } from 'react'
import { Card, Grid, Button, Form, Input, Message, GridColumn, ButtonGroup, Icon } from 'semantic-ui-react';
import '../styles/Reports.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';
import { reportsService } from '../services';
import { ReportsQueryParams, ReportSettings } from '../services/ReportsService/types';
import { RequestPayload } from '../services/ApiClient/types';
import { setToLocalTime, formatDate } from '../utils/datehelper';
const Reports = () => {

  const [isTimeout, setIsTimeout] = useState(false)
  const [loading, setLoading] = useState(false)
  const [buttonActive, setButtonActive] = useState({ Standard: false, Both: true, Custom: false })
  const [buttonType, setButtonType] = useState({ single: 1 }) //0=Standard,1=Both,2=Custom


  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.token === null || localStorage.token === undefined) {
      const navTo = `/`
      navigate(navTo)
    }
    else {
      localStorage.setItem('route', "Reports")
      getReportSettings();
    }
  }, [navigate]);

  const [reportSettings, setReportSettings] = useReducer(
    (state: ReportSettings, newState: Partial<ReportSettings>) => ({
      ...state,
      ...newState,
    }),
    {
      from: new Date(),
      to: new Date(),
      companyId: 0,
    }
  );

  const handleStartDate = (date: Date) => {
    date > reportSettings.to && setReportSettings({ to: date });
    setReportSettings({ from: date });
  }

  const handleEndDate = (date: Date) => {
    date < reportSettings.from && setReportSettings({ from: date });
    setReportSettings({ to: date })
  }

  const getReportSettings = async () => {
    let payload: RequestPayload<null> = { payload: null };
    await reportsService.GetReportSettings(payload)
      .then(response => {
        if (response.success) {
          setReportSettings(response.result)
        }
        else {
          console.error("Error getting report settings", response.message);
        }
      }).catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getReportSettings();
    setIsTimeout(false);
  }, [setReportSettings]);

  const downloadReport = async () => {
    setLoading(true)
    setIsTimeout(false);
    let query: ReportsQueryParams = {
      from: formatDate(reportSettings.from),
      to: formatDate(reportSettings.to),
      companyId: reportSettings.companyId,
      reportStyle: reportSettings.reportStyle
    }
    let payload: RequestPayload<null> = { queryParams: query, payload: null };
    await reportsService.DownloadReport(payload)
      .then(response => {
        //check if response does not contain data. 
        if (response.result.type === "application/json") {
          //set timeout message
          setIsTimeout(true);
          //keep loading effect on button
          setLoading(true)
        }
        else {
          const blob = new Blob([response.result], { type: response.result.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          let filename = response.message;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setLoading(false)
        }
      }).catch((error) => {
        console.log(error);
        setLoading(false)
      });
  }

  const buttonLayout = () => {
    switch (buttonType.single) {
      case 0:
        // setButtonActive({ Standard: true, Both: false, Custom: false })
        return (<>
          <Icon name='info circle' color='grey' size='large' title='Your Organization has allowed Only Standard reports to be available.' />
        </>)
        // return <Button color={buttonActive.Standard ? 'blue' : null} active={buttonActive.Standard} onClick={() => setButtonActive({ Standard: true, Both: false, Custom: false })}>Standard</Button>

        break;
      case 1:
        return <ButtonGroup >
          <Button color={buttonActive.Standard ? 'blue' : null} active={buttonActive.Standard} onClick={() => setButtonActive({ Standard: true, Both: false, Custom: false })}>Standard</Button>
          <Button color={buttonActive.Both ? 'blue' : null} active={buttonActive.Both} onClick={() => setButtonActive({ Standard: false, Both: true, Custom: false })}>Both</Button>
          <Button color={buttonActive.Custom ? 'blue' : null} active={buttonActive.Custom} onClick={() => setButtonActive({ Standard: false, Both: false, Custom: true })}>Custom</Button>
        </ButtonGroup >
      case 2:
        // setButtonActive({ Standard: false, Both: false, Custom: true })
        return (<>
          <Icon name='info circle' color='grey' size='large' title='Your Organization has allowed Only Custom reports to be available.' />
        </>)
      // return <Button color={buttonActive.Custom ? 'blue' : null} active={buttonActive.Custom} onClick={() => setButtonActive({ Standard: false, Both: false, Custom: true })}>Custom</Button>
      default:
        break;
    }

  }

  const sortedCompanies = reportSettings.companies
    ? Object.entries(reportSettings.companies).sort(([, a], [, b]) => a.localeCompare(b))
    : null;

  const companyOptions = [];

  if (sortedCompanies && sortedCompanies.length > 0) {
    companyOptions.push({ key: 0, text: 'All (Default)', value: 0 })
  }

  if (companyOptions.length > 0) {
    sortedCompanies.map(([key, value]: any) => companyOptions.push({ key: key, text: value, value: key }))
  }

  const reportOptions = reportSettings.reportStyles
    ? Object.entries(reportSettings.reportStyles).map(([key, value]) =>
      ({ key: key, text: value.name, value: key }))
    : null;

  const reportOptionsStandard = reportOptions?.filter(opt => parseInt(opt.key) <= 10)
  const reportOptionsCustom = reportOptions?.filter(opt => parseInt(opt.key) > 10)
  const handleDismiss = () => setIsTimeout(false);

  return (
    <div className="reports-container">
      <div className='reports-wrapper'>
        <Card className='reports-card'>
          <Card.Content style={{ backgroundColor: "#f5f5f5" }}>
            <Grid>
              <Grid.Row columns={2} style={{ display: 'flex', alignItems: 'center' }}>
                <Grid.Column width={5}>
                  <span style={{ fontSize: '18px', paddingLeft: '.2rem' }}>Run Report</span>
                </Grid.Column>
                <Grid.Column width={11}>
                  <Button disabled={reportSettings.reportStyle === null || reportSettings.reportStyle === undefined} loading={isTimeout ? false : loading} onClick={() => downloadReport()} primary color='blue' style={{ minWidth: '200px', float: 'right' }}>
                    Generate Report
                  </Button>
                </Grid.Column>
              </Grid.Row>
              {isTimeout ? (
                <Grid.Row>
                  <GridColumn style={{ paddingLeft: '2.5rem' }}>
                    <Message
                      success
                      content={'Your report is being generated in the background. We will send you the Excel document via eMail shortly.'}
                      onDismiss={handleDismiss}
                    />
                  </GridColumn>
                </Grid.Row>
              ) : ""
              }
            </Grid>
          </Card.Content>
          <Card.Content>
            <Form>
              <Form.Group style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-evenly' }}>
                <Form.Field
                  control={Input}
                  label='From Date'
                  placeholder='MM/DD/YYYY'
                >
                  <DatePicker selected={setToLocalTime(reportSettings.from)} onChange={(date) => handleStartDate(date)} />
                </Form.Field>
                <Form.Field
                  control={Input}
                  label='To Date'
                  placeholder='MM/DD/YYYY'
                >
                  <DatePicker selected={setToLocalTime(reportSettings.to)} onChange={(date) => handleEndDate(date)} />
                </Form.Field>
                {/* button form */}
                <ButtonGroup >
                  {/* <Button color={buttonActive.Standard ? 'blue' : null} active={buttonActive.Standard} onClick={() => setButtonActive({ Standard: true, Both: false, Custom: false })}>Standard</Button>
                      <Button color={buttonActive.Both ? 'blue' : null} active={buttonActive.Both} onClick={() => setButtonActive({ Standard: false, Both: true, Custom: false })}>Both</Button>
                      <Button color={buttonActive.Custom ? 'blue' : null} active={buttonActive.Custom} onClick={() => setButtonActive({ Standard: false, Both: false, Custom: true })}>Custom</Button> */}

                </ButtonGroup>
                {buttonLayout()}
              </Form.Group>
              {reportOptions &&
                <Form.Select
                  label='Report Style'
                  placeholder='Select Report'
                  value={reportSettings.reportStyle}
                  onChange={(e: any, data: any) => { setReportSettings({ reportStyle: data.value }) }}
                  // options={buttonActive.Standard ? reportOptionsStandard : buttonActive.Custom ? reportOptionsCustom : reportOptions} />
                  // options={buttonType.single === 0 ? reportOptionsStandard : buttonType.single === 2 ? reportOptionsCustom : reportOptions} />
                  options={buttonType.single === 0 ? reportOptionsStandard : buttonType.single === 2 ? reportOptionsCustom : buttonActive.Custom ? reportOptionsCustom : buttonActive.Standard ? reportOptionsStandard : reportOptions} />
              }

              {companyOptions.length > 0 &&
                <Form.Select
                  label='Company'
                  value={reportSettings.companyId}
                  onChange={(e: any, data: any) => { setReportSettings({ companyId: data.value }) }}
                  options={companyOptions}
                />
              }
            </Form>
          </Card.Content>
        </Card>

      </div>
    </div>

  )
}

export default Reports